import { router } from "@inertiajs/react"
import { useEffect } from "react"

/**
 * Reloads the Inertia page when restored from the browser's back-forward cache (bfcache).
 *
 * When a user navigates away from a page (e.g., to sign in) and then uses the browser's
 * back button, the page may be restored from bfcache with stale data (e.g., showing
 * sign-in buttons when the user is now authenticated).
 *
 * This hook detects bfcache restoration and triggers an Inertia reload to fetch fresh
 * server-side data, ensuring the UI reflects the current authentication state.
 */
export function useBfcacheReload() {
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      // event.persisted is true when the page is restored from bfcache
      if (event.persisted) {
        // Reload the Inertia page to get fresh data from the server
        router.reload()
      }
    }

    window.addEventListener("pageshow", handlePageShow)
    return () => window.removeEventListener("pageshow", handlePageShow)
  }, [])
}
